import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export const getEventBidAcceptances = (eventId, answers = []) => {
  const url = ApiUrl(`/events/${eventId}/bid_acceptances?answers=${answers}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { bid_acceptances: 'bid_acceptances' } }
  );
};

export const getBidAcceptance = id => {
  const url = ApiUrl(`/bid_acceptances/${id}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { bid_acceptance: 'bid_acceptance' } }
  );
};

export const getBidAcceptances = (answer = [], ids = []) => {
  const url = ApiUrl(`/bid_acceptances?answer=${answer}&ids=${ids}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { bid_acceptances: 'bid_acceptances' } }
  );
};

export function updateBidAcceptance (id, answer) {
  const url = ApiUrl(`/bid_acceptances/${id}`);

  return Call(
    'put',
    url,
    {
      answer
    },
    ParseGeneralResponse,
    { responseDataKeys: { bid_acceptance: 'bid_acceptance' } }
  );
}

export const declineInvitation = id => {
  const url = ApiUrl(`/bid_acceptances/${id}/decline`);

  return Call(
    'post',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { bid_acceptance: 'bid_acceptance' } }
  );
};
